// The rules under free/thumbnails.js, pure, so a test imports them: sign-file is asked for at most 20
// webinars a call, 1 per thumbnail path, a signed link is kept for 100 seconds of its 2 minutes, and
// what an answer does to the frames.
export const BATCH = 20
export const KEEP_MS = 100e3

// Lists of at most size, in order
export function batches(list, size = BATCH) {
  const out = []
  for (let i = 0; i < list.length; i += size) out.push(list.slice(i, i + size))
  return out
}

// The webinars to sign ({ id, path }): 1 per thumbnail path, in the order shown
export function wanted(webinars) {
  const seen = new Set()
  const out = []
  for (const w of webinars || []) {
    const path = w?.thumbnailPath
    if (!path || seen.has(path)) continue
    seen.add(path)
    out.push({ id: w.id, path })
  }
  return out
}

// What 1 sign-file call does to the frames ({ <path>: url, or false where the date panel shows; a path
// not there is still being signed }): asked, the paths it asked for and is still the newest call for;
// got, its answer ({ <path>: url, or false where sign-file answered and signed none }, a batch it never
// answered left out). A new link goes in. Neither false nor no answer ever takes a link off the screen;
// a path with nothing yet gets the date panel, as nothing more is coming for it.
export function merge(urls, asked, got) {
  const next = { ...urls }
  for (const path of asked) {
    if (typeof got[path] === 'string') next[path] = got[path]
    else if (typeof next[path] !== 'string') next[path] = false
  }
  return next
}

// The links kept and still fresh ({ <path>: url }), and the webinars that need signing now. store is a
// Map of path to { url, at }.
export function split(items, nowMs, store) {
  const ready = {}
  const need = []
  for (const i of items) {
    const k = store.get(i.path)
    if (k && nowMs - k.at < KEEP_MS) ready[i.path] = k.url
    else need.push(i)
  }
  return { ready, need }
}
